module.exports = __webpack_public_path__ + "img/05.9be6f4b4.png";